import React, { forwardRef, useContext, useImperativeHandle, useRef, useState } from 'react'
import { ZoomAccountFormData } from '../data/ZoomAccountForm.Data';
import FormCreator from '../../../../../components/forms/FormCreator';
import Buttons from '../../../../../components/ui/button/Buttons';

const ZoomAccount = forwardRef((props, ref) => {
    const zoomAccountRef = useRef();
    const [zoomAccountForm, setZoomAccountForm] = useState(ZoomAccountFormData);

    // Expose method `getFormData` to parent components to retrieve form data from `FormCreator`
    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const zoomAccountFormData = zoomAccountRef.current.getFormData();
                return zoomAccountFormData;
            }
            return null;
        }
    }))

    return (
        <React.Fragment>
            <div className='row'>
                <FormCreator
                    config={zoomAccountForm}
                    ref={zoomAccountRef}
                    key={false}
                />
            </div>
        </React.Fragment>
    )
})

export default ZoomAccount